import { useLandingStore } from '@stores/landings'
import { useOptionsStore } from '@stores/options'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async to => {
  const kidId = to.params?.kid as string || undefined

  if (!kidId) return

  const landingStore = useLandingStore()
  const optionsStore = useOptionsStore()

  const month = optionsStore.getCurrentMonth
    ?? await new Promise<string>(resolve => {
      const stop = watch(
        () => optionsStore.getCurrentMonth,
        (value) => {
          if (value) {
            stop()
            resolve(value)
          }
        },
      )
    })

  landingStore.setExtendedSlots(true)

  void landingStore.loadAvailableSlots({
    kidId,
    month,
    extended: true,
  })
})
